import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProductJsmAiGovernanceAuditLogsEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{},
	Record<string, never>
>;

export const productJsmAiGovernanceAuditLogsEntryPoint: EntryPoint<
	ProductJsmAiGovernanceAuditLogsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProductJsmAiGovernanceAuditLogsEntryPointComponent>(
		/* webpackChunkName: "async-product-jsm-ai-governance-audit-logs", jiraSpaEntry: "async-product-jsm-ai-governance-audit-logs" */ './ProductJsmAiGovernanceAuditLogsPage.tsx',
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => ({
		queries: {},
	}),
});
